import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function PlanScheduleList(props) {
  const Config = {
    purchase: {
      apiPath: '/schedule/batchList',
      enumMainKey: '',
      companyNameKey: 'companyName',
      detailLink: '/mp/purchase/plan/schedule/detail',
      searchBarPlaceholder:
        '供应商名称/编码、计划编号、订单编号、产品名称/编码/规格',
      tabs: ['全部', '草稿', '待答交', '待确认', '已失效'],
      countApi: '/schedule/purchaseCount',
      arrEnumField: [
        {
          mainKey: 'B02_Sch_Batch_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      countTransform: (data, self) => {
        let { 0: a, 1: b, 3: c, 5: d } = data;
        setCount([undefined, a, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        [0], // 草稿
        [1], //待答交
        [3], //待确认
        [5] //已失效
      ]
    },
    sale: {
      apiPath: '/schedule/schOrderList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/plan/schedule/detail',
      searchBarPlaceholder:
        '客户名称/编码、计划编号、订单编号、产品名称/编码/规格',
      tabs: ['全部', '待答交', '差异待确认', '退回', '已失效'],
      countApi: '/schedule/salesCount',
      arrEnumField: [
        {
          mainKey: 'B02_Sch_Order_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a, 3: b, 6: c, 7: d, 9: e } = data;
        let f = (b || 0) + (d || 0);
        setCount([undefined, a, f, c, e]);
      },
      tabConfig: [
        undefined, //全部
        [1], // 待答交
        [3, 7], // 差异待确认
        [6], // 退回
        [9] // 已失效
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //list, total参数设置
  useEffect(() => {
    setListField('content');
    setTotalField('totalElements');
  }, [setListField, setTotalField]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        batchStatus: config.tabConfig[currentTab]
      };
    } else {
      self.searchQueries = {
        orderStatus: config.tabConfig[currentTab]
      };
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${
                        self.isPurchase ? item.batchNo : item.scheduleNo
                      }`}
                      key={item.batchNo}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.batchNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('sch', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {/* {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )} */}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label> 发布人</label>
                          <div>{item.publishEmployeeName}</div>
                        </li>
                        <li>
                          <label>计划发布日期</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD HH:mm')}
                          </div>
                        </li>
                        <li>
                          <label>计划区间</label>
                          <div>
                            {formatDate(item.schStartDate, 'YYYY-MM-DD')}至
                            {formatDate(item.schEndDate, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>计划类型</label>
                          <div>
                            {item.schedulePlanType === 1
                              ? '交货计划'
                              : '预测计划'}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PlanScheduleList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PlanScheduleList);
